import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import '../../Styles/Header.css'
import Appbar from '../../Component/NavPannel/Appbar';
import DashboardRoutes from '../../Component/Layouts/DashboardLayout';


const mdTheme = createTheme();

function DashboardMain() {
 
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <div className='sidebarsetting' >
        <Appbar mainpage="Home" subpage="Dashboard"/>
          </div>
        <DashboardRoutes />
      </Box>
    </ThemeProvider>
  );
}

export default function Dashboard() {
  return <DashboardMain />
}